import api from "./api";

// 删除素材目录
export const userMaterialDeleteFolder = async (folderIds: number[]) => {
  const res = await api.post<unknown>("/user_material/delete_folder", {
    folder_ids: folderIds,
  });
  return res;
};
